'use strict';
const _ = require('underscore');
const Backbone = require('backbone');
const ActionApi = require('process/infra/api/action/index');
const ActionFactory = require('process/domain/factory/action/index');

const ActionCollection = Backbone.Collection.extend({
    getChildrenOf: function(actionId) {
        return this.filter(p => {
            return p.get('parent') && p.get('parent').id == actionId;
        });
    }
});

class Repository {
    constructor(project) {
        this._project = project;
        this._actions = new ActionCollection();
        this._fetched = {};
        this._fetchedChildren = {};
    }

    add(action) {
        return this._actions.add(action, {merge: true});
    }

    remove(action) {
        this._actions.remove(action);
    }

    on(event, callback) {
        this._actions.on(event, callback);
    }

    getByRelatedWork(workId) {
        return new Promise((resolve, reject) => {
            resolve(this._actions.filter(p => {
                return _.contains(p.get('relatedWorks'), workId);
            }));
        });
    }

    getFromCache(actionId) {
        return this._actions.get(actionId);
    }

    get(actionId) {
        return new Promise((resolve, reject) => {
            if(this._actions.get(actionId)) {
                resolve(this._actions.get(actionId));
            } else {
                this.fetchActionOnce(this._project, actionId).then((action) => {
                    this._actions.add(action, {merge: true});
                    resolve(this._actions.get(actionId));
                }, reject);
            }
        });
    }

    fetchAction(project, actionId) {
        return new Promise((resolve, reject) => {
            ActionApi.getAction(project.id, actionId)
                .then(actionJson => {
                    (new ActionFactory(project)).build(actionJson, this)
                        .then(resolve)
                }, reject);
        });
    }

    fetchActionOnce(project, actionId) {
        const key = `${project.id}:${actionId}`;
        let promise = this._fetched[key];
        if(!promise) {
            promise = this.fetchAction(project, actionId);
            this._fetched[key] = promise;
        }
        return promise;
    }

    fetchActionNoRaise(actionId) {
        if (this._actions.get(actionId)) {
            return Promise.resolve(this._actions.get(actionId));
        }
        const options = { noRaise: true };

        return new Promise((resolve, reject) => {
            ActionApi.getAction(this._project.id, actionId, options)
                .then((actionJSON) => {
                    if (!actionJSON) {
                        reject();
                    }

                    (new ActionFactory(this._project)).build(actionJSON, this)
                        .then(resolve)
                }, reject);
        });
    }

    getChildrenOf(actionId) {
        return new Promise((resolve, reject) => {
            this.fetchActionChildrenOnce(this._project, actionId).then((actions) => {
                this._actions.add(actions, {merge: true});
                resolve(this._actions.getChildrenOf(actionId));
            }, reject);
        });
    }

    fetchActionChildren(project, actionId) {
        return new Promise((resolve, reject) => {
            ActionApi.getActionChildren(project.id, actionId)
                .then(actionsJson => {
                    const factory = new ActionFactory(project);
                    Promise.all(_.map(actionsJson, (j) => {
                        if(this._actions.get(j.id)) {
                            return new Promise(resolve => {resolve(this._actions.get(j.id))})
                        } else {
                            return factory.build(j, this);
                        }
                    }, this))
                        .then(actions => {
                            resolve(actions);
                        })
                }, reject);
        });
    }

    fetchActionChildrenOnce(project, actionId) {
        const key = `${project.id}:${actionId}`;
        let promise = this._fetchedChildren[key];
        if(!promise) {
            promise = this.fetchActionChildren(project, actionId);
            this._fetchedChildren[key] = promise;
        }
        return promise;
    }
}

const repositories = {};

const find = function(project) {
    let r = repositories[project.id];
    if (!r) {
        r = new Repository(project);
        repositories[project.id] = r;
    }
    return r;
};

module.exports = {
    find: find
};



// WEBPACK FOOTER //
// ./process/domain/repository/action/index.js